const getBannerBlok = (content: any, contentType: string) => {
  const edges = content?.edges;
  if (!edges) return null;

  const domainAssociatedBannerBlocks = edges.filter((edge: any) =>
    edge.node.full_slug.includes(process.env.GATSBY_DOMAIN_FOLDER),
  );

  const bannerBlocks = domainAssociatedBannerBlocks.map((edge: any) => JSON.parse(edge.node.content));

  // Filter out banners that don't have this page uuid attached
  const bannersForThisPageType = bannerBlocks.filter((banner: any) =>
    banner.show_on_content_types.includes(contentType),
  );

  // Take the highest priority banner
  const bannerBlok = bannersForThisPageType.sort((a: any, b: any) => a.priority - b.priority)[0];

  return bannerBlok;
};

export default getBannerBlok;
